// extracted by mini-css-extract-plugin
export default {"main":"planData_main__OWqX7","imgWrap":"planData_imgWrap__Bpdem","content":"planData_content__kXs-b"};